export default {
  ALL: 'Alla',
  HAS_MODULE_FORTNOX: 'Fortnox',
  HAS_CASH_REGISTER: 'Kassa',
  IS_RENTAL_CHAIR: 'Är Hyrstol',
  HAS_RENTAL_CHAIRS: 'Har Hyrstol',
  HAS_INTEGRATED_TERMINAL: 'Terminal',
  HAS_MODULE_ACCOUNTING: 'Bokföring',
  HAS_MODULE_SALARIES: 'Lön',
  HAS_MODULE_RESOURCES: 'Resursbokning',
  SELECTED: 'Utvalda',
}
